import { ApolloError } from "@apollo/client";
import client from "../apolloClient";
import { PACKAGE_QUERIES } from "../queries/packages.queries";

export interface PackageServiceEntry {
    id: string;
    price: number;
    duration: string;
    service: {
        id: string;
        service_name: string;
    };
}

export interface SalonPackage {
    id: string;
    salon_id: string;
    package_name: string;
    package_description: string;
    salon_service_ids: string[];
    salon_services: PackageServiceEntry[];
    status: string;
    created_at: string;
    updated_at: string;
}

export interface GetAllPackagesResponse {
    success: boolean;
    message: string;
    packages: SalonPackage[];
}
  
export const getAllPackages = async (salon_id?: string): Promise<GetAllPackagesResponse> => {
  try {
    console.log('Fetching packages for salon_id:', salon_id);
    const { data, errors } = await client.query({
      query: PACKAGE_QUERIES.GET_ALL_PACKAGES,
      variables: { salon_id },
      fetchPolicy: 'network-only',
    });

    console.log('Get all packages response:', JSON.stringify(data, null, 2));
    
    if (errors) {
      throw new Error(errors[0].message);
    }
    
    return data.getAllPackages as GetAllPackagesResponse;
  } catch (error: unknown) {
    console.error('Error in getAllPackages service:', error);
    if (error instanceof ApolloError) {
      if (error.graphQLErrors) {
        console.error('GraphQL Errors:', error.graphQLErrors);
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
        console.error('Network Error Details:', JSON.stringify(error.networkError, null, 2));
      }
    }
    throw error;
  }
};